import React from "react";
import ManagersForm from "../../components/managers/ManagersForm";
import SubjectsTable from "../../components/managers/subjects/SubjectsTable";
import { RootContainer, FormContainer, TableContainer } from "./styles/ManagerViewStyles";
import { Grid } from "@mui/material";

export const ManagerView: React.FC = () => {
  return (
    <RootContainer
      container
      direction="column"
      spacing={3}
    >
      <Grid component="div" sx={{ width: '100%' }}>
        <FormContainer>
          <ManagersForm />
        </FormContainer>
      </Grid>
      <Grid component="div" sx={{ width: '100%' }}>
        <TableContainer>
          <SubjectsTable />
        </TableContainer>
      </Grid>
    </RootContainer>
  );
};
